import React from 'react';
import '../css/sections.css';

const BRANDS = [
  'Technology',
  'Finance',
  'Healthcare',
  'Energy',
  'Manufacturing',
  'Education',
  'Sustainability',
];

export default function Brands() {
  /* Duplicate the list 3× so there's always content filling the track
     on very wide screens, and the loop stays seamless at every size */
  const tripled = [...BRANDS, ...BRANDS, ...BRANDS];

  return (
    /* FIX #12: fade masks are now clamp(40px,8vw,100px) wide in CSS,
       so they never cover more than ~25% of viewport on small screens */
    <section className="brands-sec" aria-label="Trusted brands">
      <div className="wrap">
        <h4 className="brands-title">
          GLOBAL SECTORS FEATURED BY THE ELITE GLOBAL REVIEW
        </h4>
      </div>
      <div className="marquee-wrap" aria-hidden="true">
        <div
          className="marquee-track"
          /* Pause on hover/focus for accessibility */
          onMouseEnter={e => e.currentTarget.style.animationPlayState = 'paused'}
          onMouseLeave={e => e.currentTarget.style.animationPlayState = 'running'}
          onFocus={e    => e.currentTarget.style.animationPlayState = 'paused'}
          onBlur={e     => e.currentTarget.style.animationPlayState = 'running'}
        >
          {tripled.map((b, i) => (
            <div key={i} className="brand-item">{b}</div>
          ))}
        </div>
      </div>
    </section>
  );
}
